const NAME_SPACE = 'FILTERS/';

export const COUNTRY = NAME_SPACE + 'COUNTRY';
export const REGION = NAME_SPACE + 'REGION';
export const OPERATOR = NAME_SPACE + 'OPERATOR';
export const SAVED_PARKS = NAME_SPACE + 'SAVED_PARKS';
export const RESET_FILTERS = NAME_SPACE + 'RESET_FILTERS';
